import { ReactNode } from "react";
import { ClaimantCreateInputs } from "@/resources/claimants/components/ClaimantCreateInputs";
import { ClientCreateInputs } from "@/resources/clients/components/ClientCreateInputs";
import { PolicyCreateInputs } from "@/resources/policies/components/PolicyCreateInputs";
import { ReimbursementCreateInputs } from "@/resources/reimbursements/components/ReimbursementCreateInputs";
import { ClaimItemCreateInputs } from "@/resources/stoploss-claims/components/ClaimItemCreateInputs";
import { StoplossClaimCreateInputs } from "@/resources/stoploss-claims/components/StoplossClaimCreateInputs";
import { TaskCreateInputs } from "@/resources/tasks/components/TaskCreateInputs";
import { VendorCreateInputs } from "@/resources/vendors/components/VendorCreateInputs";
import { ResourceName } from "@/types";
import { TextInput, required } from "react-admin";
import { PartnerCreateInputs } from "@/resources/partners/components/PartnerCreateInputs";
import { TaskTemplateCreateInputs } from "@/resources/admin/task-templates/components/TaskTemplateCreateInputs";

export const getResourceInputs = (resource: ResourceName): ReactNode => {
  switch (resource) {
    case ResourceName.POLICIES:
      return <PolicyCreateInputs />;
    case ResourceName.CLAIMANTS:
      return <ClaimantCreateInputs />;
    case ResourceName.CLIENTS:
      return <ClientCreateInputs />;
    case ResourceName.TASKS:
      return <TaskCreateInputs />;
    case ResourceName.STOPLOSS_CLAIMS:
      return <StoplossClaimCreateInputs />;
    case ResourceName.VENDORS:
      return <VendorCreateInputs />;
    case ResourceName.REIMBURSEMENTS:
      return <ReimbursementCreateInputs />;
    case ResourceName.CLAIM_ITEMS:
      return <ClaimItemCreateInputs />;
    case ResourceName.PARTNERS:
      return <PartnerCreateInputs />;
    case ResourceName.TASK_TEMPLATES:
      return <TaskTemplateCreateInputs />;
    default:
      return [<TextInput key="title" source="title" label="Title" fullWidth validate={required()} disabled />];
  }
};
